<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-md-8">
          <div class="card-group mb-0">
            <div class="card p-2">
              <div class="card-block">
                <h1>Login</h1>
                <p class="text-muted">Sign In with your NDrive credentials</p>

                <div class="form-group" v-bind:class="{'has-danger': errors.has('email')}" >
                  <label class="form-control-label" v-show="errors.has('email')">Write a valid email</label>
                  <div class="input-group mb-1">
                    <span class="input-group-addon"><i class="icon-envelope"></i></span>
                    <input type="text" name="email" class="form-control" placeholder="your.name@ndrive.com" v-model="email" v-validate="'required|email'">
                  </div>
                </div>

                <div class="form-group" v-bind:class="{'has-danger': errors.has('login', 'auth')}">
                  <label class="form-control-label" v-show="errors.has('login', 'auth')">Login failed!</label>
                  <div class="input-group mb-2">
                    <span class="input-group-addon"><i class="icon-lock"></i></span>
                    <input type="password" name="password" class="form-control" placeholder="Password LDAP" v-model="password" v-validate="'required'" v-on:keyup.enter="login">
                  </div>
                </div>

                <div class="row">
                  <div class="col-6">
                    <button type="button" class="btn btn-primary px-2" v-on:click="login">Login</button>
                  </div>
                </div>

              </div>
            </div>
            <div class="card card-inverse card-primary py-3 hidden-md-down" style="width:44%">
              <div class="card-block text-center">
                <div>
                  <h2>Sign up</h2>
                  <p>To be able to access backoffice, please ask Devops to create an LDAP account with Backoffice access. </p>
                  <a href="mailto:devops@ndrive.com"><button type="button" class="btn btn-primary active mt-1">Register Now!</button></a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import authentication from 'services/authentication'

export default {
  name: 'Login',
  data () {
    return {
      email: '',
      password: ''
    }
  },
  watch: {
    'email': 'clearAuthErrors',
    'password': 'clearAuthErrors'
  },
  methods: {
    login () {
      this.errors.clear('auth')
      if (!this.errors.any()) {
        authentication.login(this, this.email, this.password)
      }
    },
    clearAuthErrors () {
      this.errors.clear('auth')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/pages/Login.vue